var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTravelers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.2 70.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.35 46.84 8.22 67.26a3.53 3.53 0 0 1-6.44-2.89l9.32-24.53M9 12.29a2 2 0 0 0-2.89.52l-2.26 3.41a7.9 7.9 0 0 0-1.09 3.92l.7 17.26a2.28 2.28 0 0 0 2.22 2.15h.64a3 3 0 0 0 2.72-2l5.35-18.74a3.31 3.31 0 0 0-1.13-3.32zm15.66 2.11A6.45 6.45 0 1 0 25 1.5 6.53 6.53 0 0 0 18.58 8a6.5 6.5 0 0 0 6.08 6.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7 28c-.12-3-1.75-3.13-4.25-3l-7.45.49s-12.74-7.91-12.82-7.94c-4-1.71-5.84 1.79-6.38 3.88L11.69 37.3c-.17.67-.72 4.17 1.5 6.15l11.36 9.06-.16 13.3a3.53 3.53 0 1 0 7.05 0l.16-15a3.5 3.5 0 0 0-1-2.49l-9-9 3-11.75 8.87 4.06 10.1-1.07s2.88-.34 3.13-2.56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelers);
export default __webpack_public_path__ + "static/media/travelers.1fe101a99cbac35de948cde7b0513490.svg";
export { ForwardRef as ReactComponent };